document.addEventListener("DOMContentLoaded", function () {

  const occasionSections = document.querySelectorAll(".tp-occasions");

  occasionSections.forEach(function (section) {

    const cards = section.querySelectorAll(".tp-occasion-card");

    if (!cards.length) return;

    /*
     * Lightweight interaction.
     *
     * Main hover effect CSS se handled hai.
     * JS sirf keyboard/touch accessibility
     * ke liye section ko initialize karta hai.
     */

    cards.forEach(function (card) {

      card.addEventListener("focus", function () {
        card.classList.add("is-focused");
      });

      card.addEventListener("blur", function () {
        card.classList.remove("is-focused");
      });

    });

  });

});
